import React, { useEffect, useState } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Images from "../Images";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

function Vacreqform() {
  const { account } = useSelector((state) => state?.user);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div>
      <div>
        <Header />
        <div className="inner_page position-relative pb-5">
          <img src={Images.elogo} className="elogo" alt="elogo" />
          <img
            src={Images.smallround}
            className="smallround_footer"
            alt="round"
          />
          <Container className="mt-5">
            <div className="vac_border position-relative vac_system rounded-3 py-5 px-4">
              <img src={Images.a1logo} className="a1logo" alt="round" />
              <img src={Images.a2logo} className="a2logo" alt="elogo" />
              <img src={Images.a2logo} className="a3logo" alt="elogo" />
              <Row>
                <Col xl={8} xxl={10} className="mx-auto position-relative">
                  <img
                    src={Images.smallround}
                    className="bot_round"
                    alt="round"
                  />
                  <img
                    src={Images.smallround}
                    className="top_round"
                    alt="round"
                  />
                  <div className="vac_border rounded-3 py-5 px-4">
                    <h3 className="text-center fw-600 pb-1">
                      EDAFaceVAC Request Form
                    </h3>
                    <p className="text-center">
                      Kindly fill up the form according to your request. If your
                      request(s) are not accommodated by this form, please
                      submit a ticket
                    </p>

                    <div className="pt-3 pb-2">
                      <h5>Submitter</h5>
                      <p>{account?.EmailId}</p>
                      <button className="reqbtn rounded-2 py-1 px-3">
                        View my requests
                      </button>
                    </div>

                    <hr className="reqhr"></hr>

                    <Row className="pb-4">
                      <Col lg={5}>
                        <h5 className="mt-3">New Listing Request</h5>
                        <p className="mb-2">What is your project type?</p>
                        <p className="mb-0">Need some help?</p>
                        <p>
                          Do check our{" "}
                          <Link to="#" className="linkhover">
                            FAQ
                          </Link>{" "}
                          or{" "}
                          <Link to="#" className="linkhover">
                            Methodology
                          </Link>
                        </p>
                      </Col>
                      <Col lg={7}>
                        <Row>
                          <Col xl={6}>
                            <Link className="reqform_link" to="/listcointoken">
                              <div className="borderform rounded-3 px-3 py-3 mt-3">
                                <img
                                  src={Images.icon1}
                                  className="iconimg"
                                  alt="icons"
                                />
                                <h6 className="mt-2">New Coin</h6>
                                <p className="mb-0">
                                  Built on own Mainnet.eg. Bitcoin, Monero,
                                  Zcoin etc.
                                </p>
                              </div>
                            </Link>
                          </Col>

                          <Col xl={6}>
                            <Link className="reqform_link" to="/listexchange">
                              <div className="borderform rounded-3 px-3 py-3 mt-3">
                                <img
                                  src={Images.icon3}
                                  className="iconimg"
                                  alt="icons"
                                />
                                <h6 className="mt-2">New Exchange</h6>
                                <p className="mb-0">
                                  Centralized, Decentralized and Derivative
                                  Exchanges
                                </p>
                              </div>
                            </Link>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <hr className="reqhr"></hr>

                    {/* <Row className="pb-4">
                      <Col lg={5}>
                        <div className="pe-xxl-5 mt-3">
                          <h5>Updating Coin Information</h5>
                          <p>
                            Please use this form to submit update/changes for an
                            existing coin listed onEdfaceVAC
                          </p>
                        </div>
                      </Col>
                      <Col lg={7}>
                        <Row>
                          <Col xl={6}>
                            <div className="borderform rounded-3 px-3 py-3 mt-3">
                              <img
                                src={Images.icon5}
                                className="iconimg"
                                alt="icons"
                              />
                              <h6 className="mt-2">
                                Update Coin or Token Info
                              </h6>
                              <p className="mb-0">Update/Changes information</p>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <hr className="reqhr"></hr>

                    <Row className="pb-4">
                      <Col lg={5}>
                        <div className="pe-xxl-5 mt-3">
                          <h5>Verify or Update Token Supply Information</h5>
                          <p>
                            Please use this form to verify or submit update for
                            existing token supply information; including max,
                            total, and circulating supply.
                          </p>
                        </div>
                      </Col>
                      <Col lg={7}>
                        <Row>
                          <Col xl={6}>
                            <div className="borderform rounded-3 px-3 py-3 mt-3">
                              <img
                                src={Images.icon6}
                                className="iconimg"
                                alt="icons"
                              />
                              <h6 className="mt-2">Token Supply</h6>
                              <p className="mb-0">Verify/Update Token Supply</p>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row> */}
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Vacreqform;
